import { render, staticRenderFns } from "./meniu_produse.vue?vue&type=template&id=6c75da84"
import script from "./meniu_produse.vue?vue&type=script&lang=js"
export * from "./meniu_produse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports